import React, {useEffect, useState} from "react";
import {PRODUCT_WEIGHT} from "../../../utils/shared";
import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, IconButton, Typography} from "@material-tailwind/react";
import {CheckCircleIcon, PlusIcon, XMarkIcon} from "@heroicons/react/24/solid";
import {InputComponent} from "../../../components/elements/Inputs";
import {Field, FieldArray} from "formik";
import {SelectField} from "../../../components/elements/Inputs/SelectComponent";
import FormPrices from "./FormPrices";
import {ModalComponent} from "../../../components/elements/Modal/ModalComponent";


function FormPresentation({remove, push, isView, form, values, item, helpForm, ...helpers}) {
  let index = item.indexPre;
  const [openModal, setOpenModal] = useState(false);
  const [indexToRemove, setIndexToRemove] = useState(null);
  const [indexPriceToRemove, setIndexPriceToRemove] = useState(null);

  const handleAddPrice = (arrayHelpers) => {
    arrayHelpers.push({
      price_type: '',
      amount: 0,
      status: 1,
      product: null,
      productPresentation: null
    });
  };

  const handleRemovePrice = (index, arrayHelpers, indexPrice) => {
    setIndexToRemove(index);
    setIndexPriceToRemove(indexPrice);
    setOpenModal(true);
  };

  const confirmRemovePrice = () => {
    const btnOcultoEliminarPrecio = document.getElementById(`btn-precio-eliminar-${indexPriceToRemove}`)
    btnOcultoEliminarPrecio.click()
    // console.log(helpForm)
    // helpForm.values?.presentations[indexToRemove].prices.splice(Number(indexPriceToRemove), 1);
    setIndexToRemove(null);
    setIndexPriceToRemove(null);
    setOpenModal(false);
  };

  const handleOpenModal = () => {
  }

  const closeModal = () => {
    helpers.handleOpen(false);
    if (!item.name) {
      remove(index);
    }
  }

  const validateForm = () => {
    if (!form?.errors?.presentations) {
      helpers.handleOpen(false)
    }
  }

  return (
    <>
      <Dialog
        size="md"
        className=""
        open={helpers.show}
        handler={handleOpenModal}
        dismiss={{outsidePress: false}}
      >
        <DialogHeader>
          <Typography variant="h4" className="mx-auto font-semibold pb-0 pt-4">Presentación</Typography>
          <IconButton className="border" onClick={closeModal}>
            <XMarkIcon className="text-black w-4 h-4"/>
          </IconButton>
        </DialogHeader>
        <DialogBody className="h-full overflow-y-auto max-h-[650px]">
          <div className="card  m-1 rounded-md px-4 space-y-4 ">
            <div className="grid grid-cols-1 lg:xl:2xl:grid-cols-1 gap-4">
              <div className="space-y-2">
                <InputComponent
                  name={`presentations[${index}].name`}
                  label="Nombre presentacion"
                  disabled={isView}
                />
              </div>
              <div className="space-y-2">
                <div className="w-[100%]">
                  <Field
                    name={`presentations[${index}].unit`}
                    options={PRODUCT_WEIGHT}
                    component={SelectField}
                    label="Unidad de medida"
                    disabled={isView}
                  />
                </div>
              </div>
            </div>
            <FieldArray
              name={`presentations[${index}].prices`}
              render={(arrayHelpers) => (
                <FormPrices
                  presentation={values?.presentations[index]}
                  indexPresentation={index}
                  handleRemovePrice={handleRemovePrice}
                  arrayHelpers={arrayHelpers}
                  isView={isView}
                  handleAddPrice={handleAddPrice}
                />
              )}
            />
          </div>
          <ModalComponent
            show={openModal}
            setShow={setOpenModal}
            title={'Eliminar precio'}
            message={'¿Está seguro que desea eliminar este precio?'}
            labelButtonCancel="Cancelar"
            labelButtonConfirm="Eliminar"
            onConfirm={confirmRemovePrice}
          />
        </DialogBody>
        <DialogFooter className="mx-auto w-full !justify-center mb-4">
          <Button disabled={isView || !!form?.errors?.presentations} type="button" onClick={validateForm}>
            <CheckCircleIcon className="w-5 h-5 mr-2"/>
            Guardar presentación
          </Button>
        </DialogFooter>
      </Dialog>

    </>
  );
}

export function ButtonAddItem({addAction, isView, message = 'Añadir'}) {
  return (
    <>
      {
        !isView &&
        <Button
          className="flex items-center space-x-2 bg-secondary text-black"
          onClick={addAction}
          disabled={isView}
          color="blue-gray"
        >
          <PlusIcon className="h-4 w-4"/>
          <span>{message}</span>
        </Button>
      }
    </>

  )
}

export function XIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 6 6 18"/>
      <path d="m6 6 12 12"/>
    </svg>
  )
}

export function SecondTrashIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18"/>
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
    </svg>
  )
}


export default FormPresentation